module.exports = __webpack_public_path__ + "static/img/2.eb8f1d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R134A/2.jpg
// module id = B3we
// module chunks = 1